export default __webpack_public_path__ + "images/gutters01.jpg";